import { IDidYouMeanResults } from '@models/IListingResponse';

interface Props extends IDidYouMeanResults {
  readonly searchCallback: (value: string) => void;
}

const DidYouMeanResults = ({
  didYouMeanLabel,
  suggestions = [],
  searchCallback,
}: Props) => {
  return (
    <div className="flex flex-col gap-5 md:flex-row md:items-center">
      <p className="body-one text-black-100">{didYouMeanLabel}</p>
      {suggestions.length > 0 && (
        <div className="flex flex-col items-start gap-5 md:flex-row md:items-center">
          {suggestions.map((suggestion) => (
            <button
              key={suggestion}
              className="body-one body-one--bold text-grey-600 underline hover:text-grey-450"
              onClick={() => searchCallback(suggestion)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ')
                  searchCallback(suggestion);
              }}
            >
              {suggestion}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default DidYouMeanResults;
